//Some screens can't have all options (e.g. big screens and desk stand). When the user selects a given option,
//this js disables the other options which are incompatible with it. Additionally, if after making the selection
//the set of three options currently selected do not combine to form a valid variant, alternative options will
//be automatically selected to ensure that a valid variant is picked

//Utility functions
function getOptionTypes (changedElement, currElement) {
	const changedOptionType = parseInt($( changedElement ).attr( "id" ).split('-')[1]) + 1;
	const thisOptionType = parseInt($( currElement ).attr( "id" ).split('-')[1]) + 1;
	
	let otherOptionType;
	if (changedOptionType + thisOptionType == 5) {
		otherOptionType = 1;
	} else if (changedOptionType + thisOptionType == 4) {
		otherOptionType = 2;
	} else {
		otherOptionType = 3;
	}
	
	return [changedOptionType, thisOptionType, otherOptionType];
}

function bulkToStr ( intArray ) {
	let strArray = [];
	
	intArray.forEach( (currentValue) => {
		strArray.push( currentValue.toString() );
	});
	
	return strArray;
}

//Main event handler
function updateOptionsDisplay() {

	if( $( this ).val() != "demo" ) {
		atcButton.prop("disabled", false);
		atcButton.children("span").text("Add to Basket");
		
		const changedElement = this;
		
		//Forms a selector for all elements with the same class as this
		const sameClassSelector = "." + $( changedElement ).attr("class").split(/\s+/).join(".");
		
		//For the other product option select elements which aren't the main option selector, go through each option and disable it
		//if it isn't compatible with the option that the user just selected
		$(sameClassSelector).not(this).filter(function() { return $(this).attr("id") != "SingleOptionSelector-0"; })
		.each(function() { //not() excludes this from iterating over the select element which was changed
			//Get option 'types' (1, 2 or 3)
			const [changedOptionType, thisOptionType, otherOptionType] = getOptionTypes(changedElement, this);
			
			//Converts option types to strings
			const [changedOptionTypeStr, thisOptionTypeStr, otherOptionTypeStr] = bulkToStr([changedOptionType, thisOptionType, otherOptionType]);

			const nonDemoOptions = $( this ).find( "option" ).filter(function() { return $( this ).val() != "demo"; });
			
			nonDemoOptions.each(function() { 
				let combinationIsAvailable = false;
				
				for (const variant of productJson.variants) {
					if (variant["option" + changedOptionTypeStr] == $(changedElement).val()
					&& variant["option" + thisOptionTypeStr] == $( this ).val() ) {
						combinationIsAvailable = true;
						break;
					}
				}
				
				if (combinationIsAvailable) {
					$( this ).prop("disabled", false);					
				} else {
					$( this ).prop("disabled", true);
					console.log( "Disabled " + $( this ).val() );
				}
			});			
			
		});
		
		//Update both of the other product option select elements to ensure that, in combination, they select a valid product variant
		$( sameClassSelector ).not( this ).each(function(index) { 
			
			//Get option 'types' (1, 2 or 3)
			const [changedOptionType, thisOptionType, otherOptionType] = getOptionTypes(changedElement, this);
			
			//Converts option types to strings
			const [changedOptionTypeStr, thisOptionTypeStr, otherOptionTypeStr] = bulkToStr([changedOptionType, thisOptionType, otherOptionType]);
			
			//Checks if a variant exists for the three currently-selected options, or whether there is at least one variant which combines the
			//value of the select element currently being assessed and the value of the changed select element
			var variantExists = false;
			var currOptionIsValid = false;
			
			for (const variant of productJson.variants) {
				if (variant["option" + changedOptionTypeStr] == $(changedElement).val()
				&& variant["option" + thisOptionTypeStr] == $( this ).val() ) {
					if( variant["option" + otherOptionTypeStr] == $( "#SingleOptionSelector-" + (otherOptionType - 1).toString()).val() ) {
						variantExists = true;
						break;
					} else if ( index == 0 ){
						currOptionIsValid = true;
					}
				}				
			}
			
			if ( variantExists ) {
				//If the three currently-selected options form a valid variant, none of them need to be changed
				
				return false; //Breaks the .each loop
			} else if ( index == 0 && currOptionIsValid ) {
				//If there is at least one variant which combines the value of the select element currently being assessed and the value of the
				//changed select element, the value of the select element currently being assessed doesn't need to be changed
				
				return true; //Equivalent to 'continue' - skips to next iteration in .each loop
			} else {
				
				const thisAvailableOptions = $( this ).find( "option" ).filter(function() {
					return ( $( this ).val() != "demo" && !$( this ).prop("disabled") );
				});
				//Logic for the first select element excluding the one that was changed
				if ( index == 0 ) {
					let optionToSelect;

                    let fallbackOption;
					thisAvailableOptions.each(function(index) {
						for (const variant of productJson.variants) {
							if (variant["option" + changedOptionTypeStr] == $(changedElement).val()
							&& variant["option" + thisOptionTypeStr] == $( this ).val() ) {
								if( variant["option" + otherOptionTypeStr] == $("#SingleOptionSelector-" + (otherOptionType - 1).toString()).val() ) {
									//When the currently-assessed option forms a valid variant when combined with the current values of the other
									//two select elements, stop considering other options and mark this option as to be selected
									optionToSelect = this;
									return false;
                                } else if( fallbackOption == undefined ) {
                                  fallbackOption = this;
                                }
							}
						}
					});
					
					//If an option for which the value of that option + the current values of the other product option select elements form
					//a valid variant has not been found, just select the first non-disabled and non-placeholder option
					if (optionToSelect == undefined) {
						$( fallbackOption ).prop("selected", true);
					} else {
						$( optionToSelect ).prop("selected", true);
					}	
				} 
				//Logic for the second (and final) select element excluding the one that was changed
				else {
					thisAvailableOptions.each(function() {
						for (const variant of productJson.variants) {
							if (variant["option" + changedOptionTypeStr] == $(changedElement).val()
							&& variant["option" + thisOptionTypeStr] == $( this ).val()
								&& variant["option" + otherOptionTypeStr] == $("#SingleOptionSelector-" + (otherOptionType - 1).toString()).val() ) {
									//When the currently-assessed option forms a valid variant when combined with the current values of the other
									//two select elements, stop considering other options and select this option 
									$( this ).prop("selected", true);
									return false;
							}
						}
					});
				}				
			}
		});
	} else {
		atcButton.prop("disabled", true);
		atcButton.children("span").text("Please select an option.");
	}
}

const atcButton = $("button[name='add']");
const productJson = JSON.parse($( "script#ProductJson-product-template" ).text());


$(".addoption.single-option-selector.single-option-selector-product-template.product-form__input").each(function () {
	//using func.call(this) sets the context of the function to the current select element
	$( this ).change(event => {
		updateOptionsDisplay.call(this); 
	});	
});